import { render, staticRenderFns } from "./fq-ignore.vue?vue&type=template&id=a5b02a20&scoped=true&lang=pug&"
import script from "./fq-ignore.vue?vue&type=script&lang=js&"
export * from "./fq-ignore.vue?vue&type=script&lang=js&"
import style0 from "./fq-ignore.vue?vue&type=style&index=0&id=a5b02a20&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b02a20",
  null
  
)

export default component.exports